import React, { useEffect, useState } from 'react';
import { Box, Tabs, Typography, Tab } from '@mui/material';

import Layout from '../../components/layouts/Layout';
import { AccountRoutes } from '../../routes/AccountRoutes';
import CampaignsTable from '../../components/account/companyProfile/Campaigns/CampaignsTable';
import CampaignDetails from '../../components/account/companyProfile/Campaigns/CampaignDetails';
import Loader from '../../components/common/Loader';

import useCompanyProfileRequest from '../../requests/CompanyProfileRequest';

const CompanyProfile = ({
  accessLevel,
  accessType,
  errorHandler,
  customer,
}) => {
  const { getCustomerCampaigns } = useCompanyProfileRequest();
  const [campaigns, setCampaigns] = useState([]);
  const [selectCampaign, setSelectedCampaign] = useState(null);

  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCompanyData = async () => {
      setLoading(true);
      try {
        const campaigns = await getCustomerCampaigns(errorHandler);
        console.log('Customer Data:', campaigns);
        setCampaigns(campaigns);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, []);

  const onClickCampaign = (campaignCode) => {
    setSelectedCampaign(campaignCode);
  };

  const generateBody = () => {
    return isLoading ? (
      <Loader sx={{ alignItems: 'left' }} />
    ) : (
      <>
        {campaigns.length === 0 ? null : (
          <CampaignsTable
            campaigns={campaigns}
            errorHandler={errorHandler}
            accessLevel={accessLevel}
            accessType={accessType}
            onClickCampaign={onClickCampaign}
          />
        )}
      </>
    );
  };

  return (
    <Layout
      routes={AccountRoutes}
      title={selectCampaign ? 'Campaign Details' : 'Company Profile'}
      accessLevel={accessLevel}
      accessType={accessType}
      backButtonText={selectCampaign ? 'Back to Company Profile' : null}
      handleBackButton={() => setSelectedCampaign(null)}
      isHidden={!customer.hasCampaign}
    >
      {selectCampaign ? (
        <CampaignDetails
          campaignCode={selectCampaign}
          errorHandler={errorHandler}
          accessLevel={accessLevel}
          accessType={accessType}
        />
      ) : (
        generateBody()
      )}
    </Layout>
  );
};

export default CompanyProfile;
